import { getLocaleCurrencyCode } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
//import { IAPProduct } from '@awesome-cordova-plugins/in-app-purchase-2/ngx';
import { ModalController, Platform, PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, lastValueFrom, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IosInstallComponent } from '../modals/ios-install/ios-install.component';
import { cigaroUser } from '../models/user';
import { YesNoPopupComponent } from '../popovers/yes-no-popup/yes-no-popup.component';
import { DisplayloadingService } from './displayloading.service';
import { AuthService } from './auth.service';
import { IAPProductfake } from '../models/iapppfake';


@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private api = environment.apiUrl;
  private static registeredLanguages = ['de', 'en', 'fr', 'it', 'es']; //@todo description abfragen in humidor, history, etc.
  private static defaultLanguage = 'en';
  private langUpdated = new Subject<string>();

  constructor(private http: HttpClient, private ls: DisplayloadingService,
    private translateS: TranslateService, private popc: PopoverController,
    private modc: ModalController, private platform: Platform, private authS: AuthService) {

  }
  /**
   * @description
   * Dienst ruft API auf um Farbschema am Nutzerkonto zu ändern
   * @param user
   * @param themename
   * @return boolean, true: wenn Theme geändert wurde, sonst false
   */
  public async setColorTheme(user: cigaroUser, themename: string): Promise<boolean> {
    await this.ls.presentLoading();
    const data = await lastValueFrom(
      this.http.post<any>(
        `${this.api}/set_colortheme.php`,
        { 'userID': user.id, 'theme': themename }
      )).catch(error => {
        switch (error.status) {
          default:
            return false;
        }
      });
    if (data !== false && data.message !== "theme not owned") {
      user.theme = data.theme;
      const userUpdated = JSON.stringify(user);
      localStorage.setItem("user", userUpdated);
      await this.ls.hideLoading();
      return true;
    }
    else {
      await this.ls.hideLoading();
      return false;
    }
  }
  /**
   * 
   * @returns Währungscode
   */

  public getCurrency(): string {
    const cultureLang = this.translateS.getBrowserCultureLang();
    if (cultureLang.indexOf("GB") !== -1) {
      return "GBP";
    }
    if (cultureLang.indexOf("sv") !== -1) {
      return "SEK";
    }
    if (cultureLang.indexOf("da") !== -1) {
      return "DKK";
    }
    if (cultureLang.indexOf("CH") !== -1) {
      return "CHF";
    }
    if (cultureLang.indexOf("MX") !== -1) {
      return "MXN";
    }
    if (cultureLang.indexOf("VE") !== -1) {
      return "VEF";
    }
    if (cultureLang.indexOf("de") !== -1) {
      return "EUR";
    }
    if (cultureLang.indexOf("it") !== -1) {
      return "EUR";
    }
    if (cultureLang.indexOf("FR") !== -1) {
      return "EUR";
    }
    if (cultureLang.indexOf("es") !== -1) {
      return "EUR";
    }
    else {
      const defaultLang = this.translateS.getDefaultLang();
      if (typeof (defaultLang) !== "undefined") {
        return (getLocaleCurrencyCode(defaultLang));
      }
      else {
        return "USD";
      }
    }
  }
  /**
   * @description Fügt Protokoll-Kapazität nach erfolgreichem in-App-Kauf hinzu
   * @param amount 
   */
  public async addProtocolCapacity(amount: number, productBought: IAPProductfake) {
    const data = await this.http.post<any>(`${this.api}/add_protocol_capacity.php`,
      { 'amount': amount, 'productBought': productBought }).toPromise();

    if (data.message === "protocols added") {
      this.ls.presentMessage("purchases.protocol_success", 2000, "success");
    }
    else if (data.message === "unknown error") {
      console.log(data);
      //this.ls.presentMessage("request-error.500",2000,"error");
    }
  }
  /**
   * @description
   * Schaltet die Attribute an/aus, die in der Humidor-Ansicht angezeigt werden
   * @param user 
   * @param hvAttr 
   */
  public async changeHumiView(user: cigaroUser, hvAttr: string): Promise<void> {
    await this.ls.presentLoading();
    const data = {
      userID: user.id,
      viewAttr: hvAttr
    };
    const changeViewAttr = await this.http.post<any>(`${this.api}/change_view_attr.php`, data);
    const viewChanged = await lastValueFrom(changeViewAttr);
    if (viewChanged.message === "view_attr updated") {
      switch (hvAttr) {
        case "bd":
          user.humidor_view.show_bd = !user.humidor_view.show_bd;
          break;
        case "brand":
          user.humidor_view.show_brand = !user.humidor_view.show_brand;
          break;
        case "origin":
          user.humidor_view.show_origin = !user.humidor_view.show_origin;
          break;
        case "format":
          user.humidor_view.show_format = !user.humidor_view.show_format;
          break;
        case "metric":
          user.humidor_view.show_metric = !user.humidor_view.show_metric;
          break;
        case "value":
          user.humidor_view.show_value = !user.humidor_view.show_value;
          break;
        case "archive":
          user.humidor_view.show_archive = !user.humidor_view.show_archive;
          break;
        default:
          break;
      }
      /*
      const userUpdated=JSON.stringify(user);
      localStorage.setItem("user",userUpdated);*/
      this.authS.refreshUser(user);
      await this.ls.presentMessage("useraccount.viewchange-success", 2000, "success");
      await this.ls.hideLoading();

    }
    else {
      await this.ls.presentMessage("useraccount.viewchange-error", 2000, "error");
      await this.ls.hideLoading();
    }

  }

  /**
   * @description
   * registriert den Kauf eines Farbschemas für den Nutzer
   * @param productBought 
   */
  public async registerTheme(productBought: IAPProductfake) {
    const data = await firstValueFrom(this.http.post<any>(`${this.api}/register_theme.php`,
      { 'productBought': productBought })).catch(error => {
        //this.ls.presentMessage("request-error.500",2000,"error");
      });
    if (data.message === "theme added") {
      this.ls.presentMessage("purchases.theme_success", 2000, "success");
    }
  }

  /**
    * pwaInstallCheck()
    * ------------
    * @description: Überprüft ob und welcher Installationsdialog 
    * für die PWA angezeigt werden soll
    * Ruft den Dialog dann auch auf
    */
  public async pwaInstallCheck() {
    let deferredPrompt = null;
    console.log("pwa install")
    //InstallPrompt existiert in nicht iOS-Browsern

    window.addEventListener('beforeinstallprompt', async (e) => {
      // Standard-Dialog unterdrücken
      e.preventDefault();
      console.log(e)
      // Event speichern um später auszulösen
      deferredPrompt = e;
      const shouldInstall = await this.askPWAInstall();
      if (shouldInstall === true) {//Wenn Nutzer es wünscht Installationsdialog anzeigen
        deferredPrompt.prompt();
      }
    });
    const isiOS = await this.platform.is("ios");
    const inBrowser = await this.platform.is("mobileweb");
    const isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator['standalone']);
    //Nur Installationsdialog anzeigen, wenn auf iOS Mobilgerät im Browser
    if (isiOS === true && inBrowser === true && deferredPrompt === null && isInStandaloneMode === false) {
      const shouldInstall = await this.askPWAInstall();
      if (shouldInstall === true) {
        const iInstallPop = await this.modc.create({
          component: IosInstallComponent
        });
        await iInstallPop.present();
      }
    }
  }
  /**
   * @description:
   * Generiert ein YesNo-Popover, welches fragt, ob die App
   * insstalliert werden soll
   * @returns Antwort aus YesNo-Popover/boolean
   */
  private async askPWAInstall(): Promise<boolean> {
    const installPop = await this.popc.create({
      component: YesNoPopupComponent,
      componentProps: {
        questionType: "install-pwa"
      }
    });
    await installPop.present();
    const answer = await installPop.onDidDismiss();
    //Fortsetzen
    if (typeof (answer.data) !== 'undefined' && answer.data.answer === true) {
      return true;
    }
    else {
      return false;
    }
  }

  /**
   * @description
   * Je nachdem ob das Attribut am Nutzerobjekt hängt, 
   * wird hiervon oder anhand der Browsersprache die 
   * ensprechende Sprache für den TranslateService
   * gesetzt
   */
  public async activateLanguage() {
    let languageId = "en"; //english as default
    const user = await this.authS.iPromiseaUser();
    if (user === null) {
      //kein Nutzerobjekt vorhanden -> Browsersprache verwenden
      languageId = this.translateS.getBrowserLang();
    }
    else {
      languageId = user.language;
    }
    switch (languageId) {
      case "de":
      case "en":
      case "es":
      case "fr":
      case "it":
        break;
      case "auto":
        languageId = this.translateS.getBrowserLang();
        switch (languageId) {
          case "de":
          case "en":
          case "es":
          case "fr":
          case "it":
            break;
          default:
            languageId = "en"
            break;
        }
        break;
      default:
        languageId = "en";
    }
    this.translateS.setDefaultLang(languageId);
  }
  /**
   * @description
   * Ruft Backend auf um SprachId am Nutzerobjekt in Datenbank zu setzen
   * @param languageId 
   */
  public async setLanguage(languageId: string) {
    const data = await firstValueFrom(this.http.post<any>(`${this.api}/set_language.php`,
      { 'languageId': languageId })).catch(error => {
        console.log(error);
      });
    if (typeof (data) !== "undefined") {
      switch (data.message) {
        case 'language updated':
          const user = await this.authS.iPromiseaUser();
          user.language = languageId;
          await this.authS.refreshUser(user)
          await this.activateLanguage();
          this.langUpdated.next(languageId);
          break;
        case 'language not updated':
          break;
        case 'no languageId provided':
          break;
        default:
          break;
      }
    }
  }

  public static getAllowedLanguages() {
    return this.registeredLanguages;
  }

  public static getDefaultLanguage() {
    return this.defaultLanguage;
  }

  public csUpdatedLang(): Observable<string> {
    return this.langUpdated.asObservable();
  }


}
